import { inject, Injectable, signal } from '@angular/core';
import { WindowRef } from '@spartacus/core';

export const OrderListTypes = {
  Online: 'online',
  Offline: 'offline',
} as const;

export type OrderListTypes = (typeof OrderListTypes)[keyof typeof OrderListTypes];

@Injectable()
export class OrderHistoryPageComponentService {
  orderListType = signal<OrderListTypes>(OrderListTypes.Online);
  private winRef = inject(WindowRef);

  constructor() {
    const stored = this.winRef.localStorage?.getItem('orderListType') as OrderListTypes | null;

    if (stored && Object.values(OrderListTypes).includes(stored)) {
      this.setOrderListType(stored);
    } else {
      this.setOrderListType(OrderListTypes.Online);
    }
  }

  setOrderListType(type: OrderListTypes): void {
    this.orderListType.set(type);
    this.winRef.localStorage?.setItem('orderListType', type);
  }
}
